export default {
  training: {
    code: "Code",
    hours: "Nombre d'heures",
    hours_learning: "Nombre d'heures d'enseignement",
    public: "Public prévu",
    comment: "Commentaire",
    registrants_number: "Nombre d'inscrits",
    publish_success: "Référentiel publié avec succès !",
    publish_program_success: "Programme publié avec succès !",
    domains: {
      add: {
        title: "Ajouter un domaine",
        success: "Domaine de formation ajouté avec succès !",
      },
      edit: {
        title: "Modifier ce domaine de formation",
        success: "Domaine de formation modifié avec succès !",
      },
      delete: {
        title: "Supprimer ce domaine de formation",
        confirmation: "Êtes-vous sûr de vouloir supprimer ce domaine de formation ?",
        success: "Domaine de formation supprimé avec succès !",
      },
    },
    rncp: {
      nsf_codes: "Codes NSF",
      form_codes: "Formacodes",
      rome_codes: "Codes Rome",
      targeted_activities: "Activités visées",
      domains: "Domaines",
      industry_sector_and_types_job: "Secteur d'activité et types d'emplois",
      business_sectors: "Secteurs d'activité",
      types_of_jobs: "Types d'emplois",
      due_date: "Date d'échéance",
      previous_certification: "Ancienne certification",
      new_certification: "Nouvelle certification",
      editing_competency_framework: "Édition du référentiel de compétences",
      enable_critical_learnings: "Activer les apprentissages critiques",
      critical_learning_update_success: "Préférence d'affichage des apprentissages critiques enregistrée",
      critical_learning_update_error: "Erreur lors de l'enregistrement de la préférence",
      rncp_skills: "compétences RNCP",
      missions: "missions rattachées",
      ai_suggestions: "suggestions IA",
      skills_related: "Compétences rattachées à ce bloc de compétences",
      missions_related: "Missions rattachées à ce bloc de compétences",
      ai_suggestions_related_skills: "Suggestions IA - Compétences complémentaires",
      ai_suggestions_related_missions: "Suggestions IA - Missions complémentaires",
      relaunch_ai: "Relancer (3 nouvelles)",
      triad: "Livret,",
      badge: {
        rome: "ROME",
        rncp: "RNCP",
        triad: "Livret alternant",
        job_offer: "offres d'emplois",
        offer: "offres",
        sources: "Sources",
        triads: "Livrets",
        confidence: "Confiance",
      },
      workflow: {
        skill_import_label: "Import compétences",
        enrichment_import_label: "Enrichissement IA",
        publish_import_label: "Publication",
        waiting_status_label: "À venir",
        pending_status_label: "En cours",
        finished_status_label: "Terminé",
        import_button_label: "Importer",
        enrichment_button_label: "Enrichir les compétences",
        publish_button_label: "Publier",
        enrichment_progress_title: "Import en cours",
        enrichment_step_skills: "Import des compétences",
        enrichment_step_skills_description:
          "Analyses des compétences attendues par le marché du travail et non identifiées dans le référentiel",
        enrichment_step_critical_learnings: "Import des apprentissages critiques",
        enrichment_step_critical_learnings_description:
          "Propositions argumentées de ce que saurait faire un apprenti à chaque niveau de compétence",
        enrichment_step_missions: "Import des missions",
        enrichment_step_missions_description:
          "Proposition de types de missions rattachées au bloc de compétence (sources : fiche RNCP, référentiel ROME et offres d'emploi)",
        step_status_done: "terminé",
        step_status_pending: "en cours",
        step_status_upcoming: "à venir",
        step_status_error: "en échec",
        step_status_skipped: "non terminée",
        enrichment_failed_title: "Import en échec",
        enrichment_failed:
          "Une partie de l'analyse par l'IA a échoué. Les parties réussies restent affichées ; vous pouvez relancer l'analyse.",
      },
      actions: {
        reimporting_skills: "Données existantes détectées",
      },
      modal: {
        text: "Comment souhaitez vous procéder avec le nouvel import ?",
        merge_button_title: "Fusionner",
        merge_button_text: "Conserve les données existantes et ajoute uniquement les nouvelles",
        crush_button_title: "Remplacer",
        crush_button_text: "Supprime toutes les données existantes et les remplace par les nouvelles",
        alert_title: "Une maquette existe déjà pour cette formation",
        alert_text: "Comment souhaitez-vous procéder avec les nouvelles données ?",
        submit: "Confirmer l'import",
      },
      alert: {
        empty_rncp_warning_text:
          "Pour commencer à importer des données et créer votre premier référentiel de compétence, vous devez indiquer un titre RNCP depuis le formulaire de configuration de la formation accessible par un administrateur uniquement.",
        referential_publish_title: "Publier un référentiel",
        referential_publish_sub_title: "Êtes-vous sûr de vouloir publier ce référentiel ?",
        error: "Quelque-chose n'a pas fonctionné, veuillez réessayer plus tard.",
        importing: "Données en cours d'import, veuillez patienter.",
        enriching: "Données en cours d'enrichissement, veuillez patienter.",
        update_rncp: "Pensez à mettre à jour le code RNCP dés nouvelle publication",
        rncp_sheet_import:
          "Veuillez procéder à l'import des compétences pour afficher les détails du titre RNCP de la formation.",
        rncp_skill_import:
          "Veuillez procéder à l'import des compétences pour commencer la configuration du référentiel de la formation.",
        due_date_in_month: "Échéance dans {month} mois",
        due_date_in_day: "Échéance dans {day} jours",
        empty_skills: "Aucune compétence pour le moment",
        empty_missions: "Aucune mission pour le moment",
        empty_suggestions: "Aucune suggestion, veuillez relancer l'IA pour en obtenir des nouvelles.",
        empty_block: "Aucun bloc de compétence",
      },
      level: {
        niv3: "CAP/BEP (Niveau 3)",
        niv4: "BAC (Niveau 4)",
        niv5: "BAC+2 (Niveau 5)",
        niv7: "BAC+5 (Niveau 7)",
        niv8: "Doctorat (Niveau 8)",
      },
      source_detail: {
        criticality: {
          title: "Criticité",
          low: "À surveiller",
          medium: "Émergent",
          high: "Très émergent",
        },
        pertinence: "Score de pertinence",
        criteria: {
          title: "4 critères retenus",
          pertinence_f: "Fréquence dans les offres",
          pertinence_a: "Alignement sémantique",
          pertinence_p: "Proximité métier",
          pertinence_d: "Distinctivité",
        },
        justification: "Justification IA",
        referential_presence: "Présence dans les référentiels",
        source: {
          rome: "ROME",
          esco: "ESCO",
          rncp: "RNCP",
          offres: "Offres d'emplois",
          offre: "Offre d'emploi",
          livret: "Livret",
          marche: "Marché",
        },
        source_offers: "Offres sources",
        published_at: "Publiée le",
        view_offer: "Voir l'offre",
        present: "Présent",
        absent: "Absent",
        offers_count: "{jobOfferCount} offres sur {jobOfferTotal} analysées mentionnent cette {type}.",
      },
    },
    program: {
      import_failed: "L'import du programme n'a pas fonctionné. Veuillez réessayer.",
      model: "Maquette",
      required: "Obl/Opt",
      ects: "ECTS",
      coefficient_short: "Coeff.",
      ai_confidence: "Confiance IA",
      target_audience: "Public visé",
      prerequisites: "Pré-requis",
      training_targets: "Objectifs de la formation",
      informations: "Informations pratiques",
      general_informations: "Informations générales",
      graduation: "Diplôme",
      route: "Parcours",
      rncp_code: "Code RNCP",
      graduation_type: "Type de diplôme",
      total_volume: "Volume total",
      ects_credits: "Crédits ECTS",
      add_files: "Déposez vos fichiers",
      training_program: "Programme de formation",
      duration: "Durée",
      modality: "Modalité",
      pace: "Rythme",
      location: "Lieu",
      professionalOutcomes: "Débouchés",
      extension_accepted_message: "Seuls les fichiers PDF, DOC, DOCX, XLS, XLSX et MSWORD sont acceptés",
      steps: {
        import: {
          title: "Import du programme",
          button: "Importer",
        },
        publish: {
          title: "Publication du programme",
          button: "Publier",
        },
        incoming: "À venir",
        inprogress: "En cours",
        finished: "Terminé",
      },
      actions: {
        reimporting_program: "Réimporter le programme ?",
      },
      modal: {
        text: "Un programme existe déjà pour cette formation. Comment souhaitez-vous procéder ?",
        merge_button_title: "Conserver et compléter",
        merge_button_text: "Les données existantes seront conservées, les nouvelles seront ajoutées.",
        crush_button_title: "Remplacer complètement",
        crush_button_text: "Toutes les données existantes seront supprimées et remplacées.",
        alert_title: "Important",
        alert_text: "Cette action impactera les prochains programmes publiés et les formations associées.",
        submit: "Confirmer l'import",
        "general-info": "Modifier les informations générales",
        "target-audience": "Modifier le public visé et les pré-requis",
        objectives: "Modifier les objectifs de la formation",
        "practical-info": "Modifier les informations pratiques",
      },
      training_period: {
        heading: {
          code: "Code",
          label: "Intitulé",
          type: "Type",
          required: "Obl/Opt",
          hours: "Heures",
          ects: "ECTS",
          coef: "Coef.",
          actions: "Actions",
        },
      },
      alert: {
        importing: "Données en cours d'import, veuillez patienter.",
        empty_semester:
          "Aucun semestre pour le moment, veuillez en ajouter un\n" +
          "                  manuellement en cliquant sur le bouton +",
        empty_unit:
          "Aucune unité et aucun module pour le moment, veuillez en ajouter\n" +
          "                  manuellement en cliquant sur les boutons +",
        program_import: "Veuillez procéder à l'import du programme pour commencer la configuration de la maquette",
        file_uploaded_success: "Fichier importé avec succès | {count} fichiers importés avec succès",
        file_upload_error: "Erreur lors de l'importation des fichiers",
        note: "Note",
        note_text:
          "Ces informations ont été extraites automatiquement de la maquette PDF. Vous pouvez les modifier en cliquant sur l'icône crayon.",
        warning_points: "Points d'attention",
        warning_points_text: "3 modules sans code • 2 modules nécessitent une vérification",
        empty_general_informations:
          "Veuillez procéder à l'import du programme pour afficher les informations générales",
        unit_missing_code: ({ plural, named }) =>
          plural([`${named("count")} unité sans code`, `${named("count")} unités sans code`]),
        subject_missing_code: ({ plural, named }) =>
          plural([`${named("count")} module sans code`, `${named("count")} modules sans code`]),
        unit_need_validation: ({ plural, named }) =>
          plural([
            `${named("count")} unité nécessite une vérification`,
            `${named("count")} unités nécessitent une vérification`,
          ]),
        subject_need_validation: ({ plural, named }) =>
          plural([
            `${named("count")} module nécessite une vérification`,
            `${named("count")} modules nécessitent une vérification`,
          ]),
        verification: "Données à vérifier",
        low_confidence_score:
          "L'IA a détecté ce module avec une confiance de {confidence}%. Veuillez vérifier et corriger les informations ci-dessous avant de valider.",
      },
    },
    matrix: {
      title: "Matrice UE / Compétence",
      enrich: "Relancer l'enrichissement",
      enriching: "Enrichissement de la matrice par l'IA en cours, veuillez patienter.",
      header: {
        title: "Compétences",
        block: ({ plural }) => plural(["bloc", "blocs"]),
        skill: ({ plural }) => plural(["compétence ", "compétences"]),
      },
      tooltip: {
        total: "Correspondance totale",
        secondary: "Correspondance secondaire",
        ai: "Suggestion IA - {confidence}% confiance",
      },
      tutorial: {
        title: "Guide d'utilisation de la matrice",
        line_1_with_ai:
          "<strong>Cliquez sur une cellule</strong> pour changer son état : Suggestion IA → Totale → Secondaire → Aucune → Totale",
        line_1_without_ai:
          "<strong>Cliquez sur une cellule</strong> pour changer son état : Totale → Secondaire → Aucune → Totale",
        line_2: "<strong>Activez/désactivez les suggestions IA</strong> avec le bouton en haut à gauche",
        line_3: "<strong>Dépliez les blocs et UE</strong> pour voir/masquer le détail des compétences et modules",
        line_4: "<strong>Les cellules vertes claires</strong> indiquent un lien indirect sur le niveau inférieur",
        line_5: "<strong>Les badges orange ⚠</strong> signalent les blocs/compétences sans correspondance",
        line_6: "<strong>Les correspondances modifiées sont enregistrées automatiquement",
      },
      legend: {
        title: "Légende",
        total: "Correspondance totale",
        secondary: "Correspondance secondaire",
        ai: "Suggestion IA (à valider)",
      },
      suggestion: ({ plural }) => plural(["suggestion", "suggestions"]),
      mappings: ({ plural }) => plural(["correspondance", "correspondances"]),
      mapping: {
        success: "Correspondance mise à jour avec succès !",
        removed: "Correspondance supprimée avec succès !",
        add: "Correspondance ajoutée avec succès !",
      },
    },
    contact: {
      detail: {
        title: ({ named }) => `Détail du contact ${named("name")}`,
      },
    },
    contract_list: "Liste des contrats",
    contacts: {
      success: "Contacts enregistrés avec succès !",
    },
    go_to: {
      registration: "Fiche de pré-inscription",
      contract: "Fiche contrat",
    },
    space: "Espace",
    plan_contract: {
      baseline: 'Pour selectionner l\'année sur laquelle vous travaillez cliquez sur "activer"',
    },
    stats: {
      tab_title: "Statistiques",
      export_all_excel: "Exporter tout (Excel)",
      export_all_csv: "Exporter tout (CSV)",
      export_csv: "Exporter en CSV",
      empty: "Aucune statistique disponible pour cette formation.",
      calculation_note:
        "<strong>Calcul des statistiques</strong> : taux calculés sur les questionnaires publiés et non archivés." +
        " Un trinôme est complet lorsque les 3 profils (alternant, tuteur, responsable pédagogique) ont accès au livret." +
        " Données mises à jour chaque nuit.",
      table: {
        promotion: "Promotion",
        questionnaires: "Questionnaires",
        skills: "Compétences",
        connections: "Connexions",
        triads: "Trinômes",
        export: "Export",
      },
      profiles: {
        apprentice: "Alternant",
        tutor: "Tuteur",
        apprentice_master: "Maître d'apprentissage",
      },
      indicators: {
        questionnaire_fill_rate: "Taux de remplissage des questionnaires",
        skill_fill_rate: "Taux de remplissage des compétences",
        user_connection_rate: "Taux de connexion des utilisateurs",
        completed_triads_rate: "Taux de trinômes complétés",
      },
      subcounts: {
        promotions: "promotion(s)",
        active_users: "utilisateurs actifs",
        triads: "trinôme(s)",
      },
    },
    sheet: "Fiche",
    dashboard: "Tableau de bord",
    company_contact: "Contacts entreprise",
  },
  employee: ({ plural }) => plural(["Salarié ", "Salariés"]),
};
